import { AnyAction, combineReducers, Reducer } from 'redux'
import { RouterState } from 'redux-first-history'

import { configReducer, ConfigState } from '~/config/configReducer'
import { accountReducer, AccountStateType } from '~/account/model/reducer'
import { addressBookReducer, addressBookSelectors, AddressBookState } from '~/address-book/model/reducer'
import { dashboardReducer, dashboardSelectors, DashboardState } from '~/dashboard/model/reducer'
import { basketReducer, basketSelectors, BasketState } from '~/basket/model/reducers'
import { profileReducer, profileSelectors, ProfileState } from '~/profile/model/reducers'
import { liftSelectors } from '~/util/toGlobalSelectors'

export const createRootReducer = (routerReducer: Reducer<RouterState>) =>
  combineReducers({
    router: routerReducer,
    basket: basketReducer,
    account: accountReducer,
    config: configReducer,
    addressbook: addressBookReducer,
    dashboard: dashboardReducer,
    profile: profileReducer,
  })

export type ReduxState = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  router: any // TODO: figure out types for reducers Reducer<RouterState, LocationChangeAction>
  basket: BasketState
  account: AccountStateType
  addressbook: AddressBookState
  dashboard: DashboardState
  config: ConfigState
  profile: ProfileState
}

export type ReduxAction = {
  type: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  payload: any
}

export const selectors = {
  ...liftSelectors((state: ReduxState) => state.basket, basketSelectors),
  ...liftSelectors((state: ReduxState) => state.dashboard, dashboardSelectors),
  ...liftSelectors((state: ReduxState) => state.profile, profileSelectors),
  ...liftSelectors((state: ReduxState) => state.addressbook, addressBookSelectors),
}
